import React, {useState, useEffect, useContext, useCallback} from 'react';
import styled from 'styled-components';
import { useHistory, useParams } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import autoCompleteHandlers from './autocomplete';
// import { SimpleExitHeader } from '../../components/actionHeader';
import Modal from '../../components/modal';
import LoadingIndicator from '../../components/loading';
import { Wrapper, Col, Row, Container } from '../../components/layout';
import { PresentedBy, PlayerFlag } from '../../components';
import Oval from '../../assets/images/oval.svg';
// import MacleanLogo from '../../assets/images/sponsors/maclean.png';
import CalendarIcon from '../../assets/icons/calendar.svg';
import PlusIcon from '../../assets/icons/plus-red.svg';
import { RadioInput, RadioMark, SelectInput, TextInput, TextArea } from '../../components/input';
import AutoCompleteInput from '../../components/autocomplete';
import { OutlineButtonIcon, PrimaryButtonWhite, PrimaryButton } from '../../components/buttons';
import { mobileBreakpoint, formatDraftResult, getLeagues, getTeamsByLeague, parseHeight  } from '../../lib';
import { getPlayersByYear, saveReport, getReportById, updateReport, submitMakeRequestForm, sendRequestNotifications } from '../../actions/api';
import NavigationMenu from '../../components/navigationMenu';
import { sponsorsStore } from '../../store';

const yearOptions = [];
for (let i = 2008; i < (new Date().getFullYear() + 4); i++) {
    yearOptions.unshift(String(i)) 
}

const scoreCategories = ['Skating', 'Shooting', 'Puckhandling', 'Playmaking', 'Off. Awareness', 'Def. Awareness', 'Compete'];
const goalieCategories = ['Athleticism', 'Positioning', 'Anticipation', 'Tracking', 'Rebound Control', 'Technical Skill', 'Compete']
const RadioContainer = styled.div`
    position: relative;
    cursor: pointer;
    margin: ${props => props.margin ? props.margin : '0'};
`;
const RadioLabel = styled.p`
    margin-left: 35px;
`;
const MyRadioMark = styled(RadioMark)`
    top: 0;
    left: 0;
`;
const StepHeading = styled.h3`
    font-weight: 400;
    font-size: 16px;
    margin: 0;
`
const HelpText = styled.p`
    position: absolute;
    top: -20px;
`;
const PlayerContainer = styled.div`
    display: flex;
    width: 100%;
    min-height: 310px;
    align-items: center;
    padding: 0 40px;
    background-color: #161718;
    margin-bottom: 60px;
    @media(max-width: 900px){
        flex-direction: column;
        padding: 25px 15px;
    }
`;

const FirstColumn = styled(Col)`
    flex: 0 0 32%;
    align-self: center;
    flex-wrap: wrap;
    @media(max-width: 900px){
        flex: 0 1 100%;
    }
`;

const SecondColumn = styled(Col)`
    flex: 0 0 68%;
    align-self: center;
    flex-wrap: wrap;
    @media(max-width: 900px){
        flex: 0 1 100%;
    }
`;

const ProfileImageContainter = styled.div`
    position: relative;
    width: 200px;
    margin-right: 60px;
    @media(max-width: 900px){
        margin-right: 0px;
    }
`;

const ProfileImage = styled.div`
    padding-bottom: 100%;
    border-radius: 100%;
    background: #333 no-repeat center;
    background-size: cover;
    background-image: ${props => props.src ? `url(${props.src})` : 'url(https://nhlentrydraft.com/wp-content/themes/fc-hockey/img/profile-fallback.jpg)'};
`;

const FirstName = styled.h3`
    font-size: 18px;
    margin: 0;
    margin-bottom: 10px;
`;
const LastName = styled.h3`
    font-size: 44px;
    font-weight: 700;
    margin: 0;
`;

const RankContainer = styled.div`
    position: relative;
    line-height: 44px;
    height: 44px;
    padding-right: 54px;
    margin: 0 10px 10px 0;
    &:before {
        content: "";
        display: inline-block;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: #000;
        border-right: 54px solid #D6001C;
        transform: skewX(-12deg);
    }
    & span:nth-child(1){
        position: relative;
        font-size: 18px;
        font-weight: 700;
        text-transform: uppercase;
        padding: 0 20px;
    }
    & span:nth-child(2){
        position: absolute;
        top: 0;
        right: 0;
        width: 54px;
        text-align: center;
        font-size: 24px;
        font-weight: 700;
    }
    @media(max-width: 900px){
        margin: 20px 0;
    }
`;

const SubHeading = styled.span`
    font-size: 12px;
    font-weight: 700;
    font-family: 'Roboto Condensed';
    text-transform: uppercase;
    margin-bottom: 10px;
    @media(max-width: 530px){
        font-size: 10px;
    }
`;

const P = styled.p`
    @media(max-width: 530px){
        font-size: 14px;
    }
`;

const Category = styled.div`
    background-color: #161718;
    height: 60px;
    margin-bottom: 5px;
    padding-left: 20px;
    display: flex;
    @media(max-width: 530px){
        font-size: 12px;
    }
`;

const Score = styled.span`
    cursor: pointer;
    z-index: 1;
    margin-right: 0px;
    padding: ${props => props.index === 10 ? '6px 6px' : '6px 10px'};
    justify-content: center;
    align-items: center;
    border-radius: 100%;
    text-align: center;
    display: flex;
    @media(max-width: 530px){
        padding: ${props => props.index === 10 ? '4px 4px' : '4px 8px'};
        justify-content: flex-start;
        align-items: flex-start;
    }
`;

const AnalysisContainer = styled.div`
    background-color: #161718;
    height: 455px;
    display: flex;
    flex-direction: column;
`;

const GameScoreContainer = styled(Row)`
    align-content: center;
    background-color: #161718;
    height: 100px;
    padding: 0 30px;
    margin-bottom: 60px;
    @media(max-width: 900px){
        height: 200px;
    }
`;

const H2 = styled.h2`
    margin: 0;
`;

const ReportsWrapper = styled(Wrapper)`
    padding-top: 0;
`;

const parseScores = (scores) => {
    return scores.athleticism ? [scores.athleticism, scores.positioning, scores.anticipation, scores.tracking, scores.rebound_control, scores.technical_skill, scores.compete].map((x) => parseInt(x)) :
    [scores.skating, scores.shooting, scores.puckhandling, scores.playmaking, scores.offensive_awarness, scores.defensive_awarness, scores.compete].map((x) => parseInt(x));
}
// const parseDate = (date) => {
//     const splitDate = new Date(date).toLocaleString('en-us', {year:'numeric',month: 'numeric',day: 'numeric'}).split('/');
//     return `${splitDate[2]}-${pad(splitDate[0])}-${pad(splitDate[1])}`;
// }

function OvalBg(){
    const isSmallMobile = useMediaQuery({maxWidth: 530});
    return <div style={{position: 'absolute', zIndex: 0}}>
        <img alt="" src={Oval} width={isSmallMobile ? '22px' : ''}></img>
    </div>;
}

function ScoreCard({values, handleSetScore, type}){
    const isSmallMobile = useMediaQuery({maxWidth: 530});
    const categories = type === 'field' ? scoreCategories : goalieCategories;
    return categories.map((cat, catId) => 
        <Category key={cat}>
            <Col size={isSmallMobile ? '25%' : '30%'} alignSelf="center">{cat}</Col>
            <Col size={isSmallMobile ? '75%' : '70%'} alignSelf="center">
                {Array(11).fill().map((x, score) =>
                    <span style={{position: 'relative', display: 'flex', width: '8%'}}>
                    <Score
                        index={score}
                        key={`${cat}-${score}`}
                        onClick={() => handleSetScore(catId, score)}
                        checked={values[catId] === score}>
                            {score}
                    </Score>
                    {values[catId] === score && <OvalBg/>}
                    </span>
                )}
            </Col>
        </Category>
    )
}

function Radio({ onChange, checked, label, margin }){
    return <RadioContainer onClick={onChange} margin={margin}>
        <RadioInput type="radio" checked={checked} readOnly/>
        <MyRadioMark checked={checked} />
        <RadioLabel>{label}</RadioLabel>
    </RadioContainer>
}

function ReportsBuilder(){
    let history = useHistory();
    let { reportId } = useParams();
    const isMobile = useMediaQuery({maxWidth: mobileBreakpoint});
    const [ formValues, setFormValues ] = useState({
        event: 'Single Game Report',
        year: '2025',
        selectedPlayer: {},
        scores: [0,0,0,0,0,0,0],
        league: '',
        team_1: '',
        team_1_score: '',
        team_2: '',
        team_2_score: '',
        date: '',
        title: '',
        analysis: '',
        type: 'Live Viewing',
        playerPosition: 'field',
        waitForInitial: true,
    });
    const [ requestFormValues, setRequestFormValues ] = useState({
        requestName: '',
        requestTeam: '',
        requestLeague: '',
        requestDetails: '',
    });
    const { event, year, selectedPlayer, scores, league, team_1, team_1_score,
            team_2,team_2_score,date,title,analysis, type, playerPosition, waitForInitial } = formValues;
            
    const { requestName, requestTeam, requestLeague, requestDetails} = requestFormValues;
    
    const { state: { reportsBuilder } } = useContext(sponsorsStore);
    const [ players, setPlayers ] = useState([]);
    const [ isRequestModalOpen, setRequestModalOpen ] = useState(false);
    const [ initialData, setInitialData ] = useState('');
    const [ playerInputValue, setPlayerInputValue ] = useState('');
    const [ leagueInputValue, setLeagueInputValue ] = useState('');
    const [ awayTeamInputValue, setAwayTeamInputValue ] = useState('');
    const [ homeTeamInputValue, setHomeTeamInputValue ] = useState('');
    const [ loading, setLoading ] = useState(false);
    const canSubmit = title && analysis && Object.keys(selectedPlayer).length;
    
    document.title = "Reports Builder - FCHockey";

    const handleSetScore = (category, score) => {
        const newScores = [...scores];
        newScores[category] = score;
        setFormValues({...formValues, scores: newScores });
    }

    const handlePlayerChange = useCallback((value) => {
        // setFormValues({...formValues, selectedPlayer: {...value}, playerPosition: value.position === 'G' ? 'goalie' : 'field'});
        setFormValues(prevFormValues => ({...prevFormValues, selectedPlayer: {...value}, playerPosition: value.position === 'G' ? 'goalie' : 'field'}));
    }, []);
    const handleFormChange = useCallback((value, key) => {
        // setFormValues({...formValues, [key]: value});
        setFormValues(prevFormValues => ({...prevFormValues, [key]: value}));
    }, []);

    const handleSubmit = async(status) => {
        try {
            setLoading(true);
            const payload = { event, selectedPlayer, league, team_1, team_1_score, team_2, team_2_score,
                date, scores, title, analysis, type, year };
            if(initialData.id) {
                await updateReport( {...payload}, status, initialData.id);
            }
            else {
                await saveReport( {...payload}, status);
            }
            setLoading(false);
            history.push('/my-reports');
        }
        catch(error){
            setLoading(false);
        }
    }

    const handleRequestSubmit = async() => {
        try {
            setLoading(true);
            const payload = { requestName, requestLeague, requestTeam, requestDetails };
            const response = await submitMakeRequestForm(payload);
            await sendRequestNotifications(response.id);
            setLoading(false);
            setRequestModalOpen(false);
        }
        catch(error){
            setLoading(false);
        }
    }

    useEffect(() => {
        if(players && initialData.player && !Object.keys(selectedPlayer).length) {
            const playerToSelect = players.filter((x) => x.wpID === initialData.player);
            if(!playerToSelect.length) return;
            handlePlayerChange(playerToSelect[0]);
            setPlayerInputValue(initialData.player_name);
            setLeagueInputValue(initialData.league);
            setAwayTeamInputValue(initialData.team_1);
            setHomeTeamInputValue(initialData.team_2);
        }
    }, [
        players,
        handlePlayerChange,
        initialData.league,
        initialData.player,
        initialData.player_name,
        initialData.team_1,
        initialData.team_2,
        selectedPlayer
    ])

    useEffect(()=>{
        const fetchPlayers = async () => {
            try {
                setLoading(true);
                let players = await getPlayersByYear(year);
                setPlayers(players);
                setLoading(false);
            }
            catch(error){
                setLoading(false);
            }
        }
        if(!waitForInitial){
            fetchPlayers();
        }
    },[year, waitForInitial]);

    useEffect(()=>{
        if(reportId && initialData){
            setFormValues({
                ...formValues,
                ...initialData,
                year: initialData.draft_year,
                //CHECK FOR PLAYER POSITION AND CHANGE ACCORD
                playerPosition: initialData.athleticism ? 'goalie' : 'field',
                scores: parseScores(initialData),
                date: initialData.event !== 'Summary' && initialData.date,
                waitForInitial: false
            });
        }
    },[initialData, formValues, reportId]);

    useEffect(() => {
        const fetchReport = async () => {
            try {
                setLoading(true);
                const { data, title, id, date, unformated_analysis } = await getReportById(reportId);
                setInitialData({...data, title, id, date, analysis: unformated_analysis});
                setLoading(false);
            }
            catch (error){
                setLoading(false);
            }
        };
        if(reportId) fetchReport();
        else handleFormChange(false, 'waitForInitial');
    },[handleFormChange, reportId]);

    return(
    <ReportsWrapper>
        <Modal title="Make a request" isOpen={isRequestModalOpen} closeModal={() => setRequestModalOpen(false)} isRequest>
            <Row>
                    <Row margin="0 0 35px 0">
                        <TextInput width="100%" placeholder="Player's Name" value={requestName} onChange={(e)=>setRequestFormValues({...requestFormValues, requestName: e.target.value})}/>
                    </Row>
                    <Row margin="0 0 35px 0">
                        <TextInput width="100%" placeholder="Team name" value={requestTeam} onChange={(e)=>setRequestFormValues({...requestFormValues, requestTeam: e.target.value})}/>
                    </Row>
                    <Row margin="0 0 35px 0">
                        <TextInput width="100%" placeholder="League" value={requestLeague} onChange={(e)=>setRequestFormValues({...requestFormValues, requestLeague: e.target.value})}/>
                    </Row>
                    <Row margin="0 0 35px 0">
                        <TextInput width="100%" placeholder="Additional Details" value={requestDetails} onChange={(e)=>setRequestFormValues({...requestFormValues, requestDetails: e.target.value})}/>
                    </Row>
            </Row>
            <Row justifyContent="center">
                <PrimaryButton padding="10px 50px" onClick={handleRequestSubmit} disabled={!requestName || !requestTeam || !requestLeague || loading}>Submit</PrimaryButton>
            </Row>
        </Modal>
        <NavigationMenu noPadding/>
        <Row justifyContent="space-between" alignItems="center" margin="0 0 40px 0">
            <Col> <h1>Report Builder</h1></Col>
            <Col alignItems="center">
                <PresentedBy logo={reportsBuilder.url} ></PresentedBy>
            </Col>
        </Row>
        <Row margin="0 0 45px 0">
            <Col margin="10px 70px 0 0">
                <Radio
                    checked={event === 'Summary'}
                    onChange={ ()=> handleFormChange('Summary', 'event')}
                    label="Summary"
                />
            </Col>
            <Col margin="10px 0 0 0">
                <Radio
                    checked={event === 'Single Game Report'}
                    onChange={ ()=>handleFormChange('Single Game Report', 'event')}
                    label="Single Game Report"
                />
            </Col>
        </Row>
        <Row>
            <StepHeading><b>Step 1</b> of {event === 'Summary' ? 2 : 3}</StepHeading>
        </Row>
        <Row margin="0 0 20px 0">
            <h2>Player Info</h2>
        </Row>
        <Row justifyContent="space-between" margin="0 0 30px 0">
            <Col>
                <SelectInput
                    width="150px"
                    margin="0 15px 0 0"
                    options={yearOptions.map((opt)=>({label:opt,value:opt}))}
                    value={year}
                    onChange={(e) => {
                        setFormValues({...formValues, year: e.target.value, selectedPlayer: {}});
                        setPlayerInputValue('');
                    }}
                    disabled={loading}
                />
                {!isMobile && <AutoCompleteInput
                    width="330px"
                    id="players"
                    type="players"
                    value={playerInputValue}
                    setValue={setPlayerInputValue}
                    onSelected={(e, {suggestion, suggestionValue}) => handlePlayerChange(suggestion)}
                    placeholder="Search by player name"
                    disabled={!players.length || loading}
                    values={players}
                    getSuggestions={autoCompleteHandlers['players']['getSuggestions']}
                    getSuggestionValue={autoCompleteHandlers['players']['getSuggestionValue']}
                    renderSuggestion={autoCompleteHandlers['players']['renderSuggestion']}
                />}
            </Col>
            {!isMobile && <Col style={{position: 'relative'}}>
                <HelpText>Can't find a player ?</HelpText>
                <OutlineButtonIcon marginLeftIcon="5px" icon={PlusIcon} onClick={() => setRequestModalOpen(true)}>
                    Make a request
                </OutlineButtonIcon>
            </Col>}
        </Row>
        {isMobile && 
        <Row margin="0 0 30px 0">
            <AutoCompleteInput
                width="300px"
                id="players"
                type="players"
                value={playerInputValue}
                setValue={setPlayerInputValue}
                onSelected={(e, {suggestion, suggestionValue}) => handlePlayerChange(suggestion)}
                placeholder="Search by player name"
                disabled={!players.length || loading}
                values={players}
                getSuggestions={autoCompleteHandlers['players']['getSuggestions']}
                getSuggestionValue={autoCompleteHandlers['players']['getSuggestionValue']}
                renderSuggestion={autoCompleteHandlers['players']['renderSuggestion']}
            />
        </Row>}
        {loading ? <LoadingIndicator /> : <Container>
            {!!Object.keys(selectedPlayer).length ? <PlayerContainer>
                <FirstColumn>
                    <ProfileImageContainter>
                        <ProfileImage src={selectedPlayer.profileImage}></ProfileImage>
                    </ProfileImageContainter>
                </FirstColumn>
                <SecondColumn>
                    <Row justifyContent={isMobile ? 'flex-start' : 'space-between'} alignItems={isMobile ? 'center' : ''} margin={isMobile ? '15px 0 0 0' : '0 0 45px 0'} flexDirection={isMobile ? 'column' : 'row'} >
                        <Col flexDirection="column">
                            <FirstName>{selectedPlayer.firstName}</FirstName>
                            <LastName>{selectedPlayer.lastName}</LastName>
                        </Col>
                        <Col>
                            <RankContainer>
                                <span>FC RANK</span>
                                <span>{selectedPlayer.fcRank === 999 ? 'N/A' : selectedPlayer.fcRank === 1111 ? 'A' : selectedPlayer.fcRank === 2222 ? 'B' : selectedPlayer.fcRank === 3333 ? 'C' : selectedPlayer.fcRank === 4444 ? 'D' : selectedPlayer.fcRank}</span>
                            </RankContainer>
                        </Col>
                    </Row>
                    <Row margin="0 0 30px 0">
                        <Col flexDirection="column" size="40%">
                            <SubHeading>Date of birth</SubHeading>
                            <P>{selectedPlayer.dateOfBirth}</P>
                        </Col>
                        <Col flexDirection="column" size="20%">
                            <SubHeading>Position</SubHeading>
                            <P>{selectedPlayer.position}</P>
                        </Col>
                        <Col flexDirection="column" size="20%">
                            <SubHeading>Height</SubHeading>
                            <P>{parseHeight(selectedPlayer.height)}</P>
                        </Col>
                        <Col flexDirection="column" size="20%">
                            <SubHeading>Draft Year</SubHeading>
                            <P>{year}</P>
                        </Col>
                    </Row>
                    <Row>
                        <Col flexDirection="column" size="40%">
                            <SubHeading>Place of birth</SubHeading>
                            <P><PlayerFlag width="28px" height="15px" marginLeft="0px" player={selectedPlayer}/></P>
                        </Col>
                        <Col flexDirection="column" size="20%">
                            <SubHeading>Shoots</SubHeading>
                            <P>{selectedPlayer.shoot === 'R' ? 'Right' : 'Left'}</P>
                        </Col>
                        <Col flexDirection="column" size="20%">
                            <SubHeading>Weight</SubHeading>
                            <P>{selectedPlayer.weight}lbs</P>
                        </Col>
                        <Col flexDirection="column" size="20%">
                            <SubHeading>Draft Result</SubHeading>
                            <P>{formatDraftResult(selectedPlayer)}</P>
                        </Col>
                    </Row>
                </SecondColumn>
            </PlayerContainer> : <Row margin="0 0 30px 0" justifyContent="center"><Col><h3 style={{textAlign: 'center'}}>Add a player to your report by searching above</h3></Col></Row>}
            
            {event === 'Single Game Report' && (
                <>
                    <Row>
                        <StepHeading><b>Step 2</b> of 3</StepHeading>
                    </Row>
                    <h1>Game Results</h1>
                    <Row justifyContent="space-between" alignItems="center" margin="0 0 30px 0">
                        <Col>
                            <TextInput
                                width="185px"
                                margin="0 20px 0 0"
                                type="date"
                                icon={CalendarIcon}
                                value={date}
                                min="2008-01-01"
                                max="2025-12-31"
                                onChange={(e) => handleFormChange(e.target.value, 'date')}
                            />
                            {!isMobile && <AutoCompleteInput
                                width="330px"
                                id="leagues"
                                type="leagues"
                                value={leagueInputValue}
                                setValue={setLeagueInputValue}
                                onSelected={(e, {suggestion, suggestionValue}) => handleFormChange(suggestion, 'league')}
                                placeholder="Search by league name"
                                disabled={false}
                                values={getLeagues()}
                                getSuggestions={autoCompleteHandlers['simple']['getSuggestions']}
                                getSuggestionValue={autoCompleteHandlers['simple']['getSuggestionValue']}
                                renderSuggestion={autoCompleteHandlers['simple']['renderSuggestion']}
                            />}
                        </Col>
                        {isMobile && <Col margin="20px 0">
                            <AutoCompleteInput
                                width="330px"
                                id="leagues"
                                type="leagues"
                                value={leagueInputValue}
                                setValue={setLeagueInputValue}
                                onSelected={(e, {suggestion, suggestionValue}) => handleFormChange(suggestion, 'league')}
                                placeholder="Search by league name"
                                disabled={false}
                                values={getLeagues()}
                                getSuggestions={autoCompleteHandlers['simple']['getSuggestions']}
                                getSuggestionValue={autoCompleteHandlers['simple']['getSuggestionValue']}
                                renderSuggestion={autoCompleteHandlers['simple']['renderSuggestion']}
                            />
                        </Col>}
                        <Col>
                            <Radio
                                checked={type === 'Live Viewing'}
                                onChange={()=>handleFormChange('Live Viewing', 'type')}
                                label="Live Viewing"
                                margin="0 40px 0 0"
                            />
                            <Radio
                                checked={type === 'Video Review'}
                                onChange={()=>handleFormChange('Video Review', 'type')}
                                label="Video Review"
                            />
                        </Col>
                    </Row>
                    <GameScoreContainer>
                        <Col size={isMobile ? '100%' : '45%'} alignSelf="center">
                            <AutoCompleteInput
                                id="away-team"
                                type="teams"
                                width="80%"
                                marginRight="30px"
                                value={awayTeamInputValue}
                                setValue={setAwayTeamInputValue}
                                onSelected={(e, {suggestion, suggestionValue}) => handleFormChange(suggestion, 'team_1')}
                                placeholder="Away Team"
                                disabled={!league.length}
                                values={getTeamsByLeague(league)}
                                getSuggestions={autoCompleteHandlers['simple']['getSuggestions']}
                                getSuggestionValue={autoCompleteHandlers['simple']['getSuggestionValue']}
                                renderSuggestion={autoCompleteHandlers['simple']['renderSuggestion']}
                            />
                            <TextInput width="20%" placeholder="Score" value={team_1_score} onChange={(e) => handleFormChange(e.target.value, 'team_1_score')} type="number"/>
                        </Col>
                        <Col margin={isMobile && '25px 0 15px 0'} size={isMobile ? '100%' : '10%'} justifyContent="center" alignItems="flex-end" alignSelf="center">
                            <H2>AT</H2>
                        </Col>
                        <Col size={isMobile ? '100%' : '45%'} alignSelf="center">
                            <AutoCompleteInput
                                id="home-team"
                                type="teams"
                                width="80%"
                                marginRight="30px"
                                value={homeTeamInputValue}
                                setValue={setHomeTeamInputValue}
                                onSelected={(e, {suggestion, suggestionValue}) => handleFormChange(suggestion, 'team_2')}
                                placeholder="Home Team"
                                disabled={!league.length}
                                values={getTeamsByLeague(league)}
                                getSuggestions={autoCompleteHandlers['simple']['getSuggestions']}
                                getSuggestionValue={autoCompleteHandlers['simple']['getSuggestionValue']}
                                renderSuggestion={autoCompleteHandlers['simple']['renderSuggestion']}
                            />
                            <TextInput width="20%" placeholder="Score" value={team_2_score} onChange={(e) => handleFormChange(e.target.value, 'team_2_score')} type="number"/>
                        </Col>
                    </GameScoreContainer>
                </>
            )}
            
            <Row>
                <StepHeading><b>Step {event === 'Summary' ? 2 : 3}</b> of {event === 'Summary' ? 2 : 3}</StepHeading>
            </Row>
            <h1>Player Report</h1>
            <Row>
                <Col size={isMobile ? '100%' : '48%'} flexDirection="column">
                    <Row>
                        <h2>Scorecard</h2>
                    </Row>
                    <ScoreCard values={scores} handleSetScore={handleSetScore} type={playerPosition} />
                    <Row margin="50px 0 0 0" justifyContent={isMobile ? 'center' : 'flex-end'}>
                        {!isMobile && <PrimaryButtonWhite onClick={() => handleSubmit('draft')}>Save {event}</PrimaryButtonWhite>}
                    </Row>
                </Col>
                {!isMobile && <Col size="4%"></Col>}
                <Col size={isMobile ? '100%' : '48%'} flexDirection="column">
                    <Row>
                        <h2>Analysis</h2>
                    </Row>
                    <AnalysisContainer>
                        <Row justifyContent="center" margin="20px 0 20px 0">
                            <TextInput width="85%" placeholder="Enter title" value={title} onChange={(e)=>handleFormChange(e.target.value, 'title')}/>
                        </Row>
                        <Row justifyContent="center">
                            <TextArea width="85%" placeholder="Enter analysis" value={analysis} onChange={(e)=>handleFormChange(e.target.value, 'analysis')}/>
                        </Row>
                    </AnalysisContainer>
                    <Row margin="50px 0 0 0">
                        {!isMobile && <PrimaryButton disabled={!canSubmit} onClick={() => handleSubmit('pending')}>Request to publish</PrimaryButton>}
                    </Row>
                </Col>
            </Row>
            {isMobile &&
            <Row justifyContent="space-between" margin="0 0 25px 0">
                <Col margin="10px 0 0 0" >
                    <PrimaryButtonWhite padding="10px 20px" disabled={!canSubmit} onClick={() => handleSubmit('draft')}>Save {event === 'Summary' ? 'Summary' : 'Report'}</PrimaryButtonWhite>
                </Col>
                <Col margin="10px 0 0 0" >
                    <PrimaryButton padding="10px 20px" disabled={!canSubmit} onClick={() => handleSubmit('pending')}>Request to publish</PrimaryButton>
                </Col>
            </Row>}

        </Container>}

    </ReportsWrapper>);
}

export default ReportsBuilder;